module.exports = __webpack_public_path__ + "img/20230822144802970dp8.8c38cd08.jpg";